import { memo } from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar = memo(function ProgressBar({ current, total }: ProgressBarProps) {
  const pct = total > 0 ? Math.min((current / total) * 100, 100) : 0;

  return (
    <div className="progress-bar" role="progressbar" aria-valuenow={current} aria-valuemax={total}>
      <div className="progress-fill" style={{ width: `${pct}%` }} />
    </div>
  );
});

export default ProgressBar;
